<template>
  <div class="row">
    <div class="col-left" v-if="showWelcome">
      <div>
        <Login />
      </div>
    </div>
    <div class="col-right" v-if="showWelcome">
      <div>
        <img :src="$config.get('basePathFiles') + 'static/img/logo.png'" style="height:96px; margin: 0 auto; display: block; margin-bottom: 10px;">
        <div v-if="utils.isParentApp()">
          <h1> Welcome to miEbooks for Parents</h1>
          <div class="intro">
            miEbooks is used daily by more than 100,000 students across the world. It gives students access to more than 300,000 educational, trade, and free e-books from more than 9,000 publishers on the ITSI Store... and that’s just part of it.
            <br /><br />
            This interactive analytics tool allows parents to:

            <ul style="text-align: left">
              <li>See their child's analytics, which includes time spent in each book, resources opened, engagement score etc.</li>
              <li>Monitor their child's realtime interactions with miEbooks</li>
              <li>See their child's upcoming events</li>
              <li>Access the newsletter</li>
            </ul>
          </div>
        </div>
        <div v-else>
          <h1> Welcome to miEbooks for Web</h1>
          <div class="intro">
            miEbooks is used daily by more than 100,000 students across the world. It gives students access to more than 300,000 educational, trade, and free e-books from more than 9,000 publishers on the ITSI Store... and that’s just part of it.
            <br /><br />
            This interactive learning tool also allows students to:

            <ul style="text-align: left">
              <li>Create notes and freehand drawings</li>
              <li>Highlight important text</li>
              <li>Generate summaries</li>
              <li>Create your own folders and upload content</li>
              <li>Create flashcards for interactive studying</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import userUtils from '@/utils/userUtils.js';
  import Login from './Login';
  
  export default {
    name: 'Welcome',
    components: {
      Login
    },
    data: function () {
      var t = this;

      return {
        showWelcome: false,
        utils: utils
      }
    },
    mounted: function () {
      if (userUtils.isLoggedIn(this.$store)) {
        utils.goHome(this);
      } else {
        this.showWelcome = true;
      }
    },
    methods: {}
  }
</script>


<style scoped lang="scss">
@import "src/css/vars.scss";

.lets-start {
  margin-bottom: 20px
}

.lets-start > div {
  color: $primary-color;
}
.next-button {
  margin-top: 15px;
  background: $primary-color;
  color: white;
}

.error {
  margin-top: 10px;
  color: red;
}

h1 {
  font-size: 17pt;
}

label {
  margin: 25px 0 15px;
  display: block;
  font-weight: bold;
}

.vbta {
  max-width: 500px;
}

.intro {
  margin: 20px auto 0;
  max-width: 700px;
  text-align: left;
  line-height: 1.55;
}

.col-left > div, .col-right > div {
  text-align: center;
  padding: 50px 30px;
}

.col-left {
  background: $background-color;
  -webkit-box-shadow: 2px 2px 15px 0px rgba(184,184,184,0.3);
  -moz-box-shadow: 2px 2px 15px 0px rgba(184,184,184,0.3);
  box-shadow: 2px 2px 15px 0px rgba(184,184,184,0.3);

  width: 33%; 
  text-align: center;    
  font-size: 11pt;
  display: inline-block;
}

.col-right {
  margin-left: -4px;
  color: $dark-font-color;
  display: inline-block;
  text-align: center;
  width: 66%;
  vertical-align: top;
  padding: 10px 10px;
  min-height: calc(100vh - 3px);
}

ul {
  list-style: disc;
  margin-left: 20px;
  padding: 10px 0;
}

.row {
  background: rgba(34, 104, 196, 0.15); 
  display: flex;
}

@media screen and (max-width: 1000px) {
  .row {
    display: block;
  }
  
  .next-button {
    float: none;
    display: block;
    width: 70px;
    margin: 15px auto;
  }

  .col-left {
    width: 100%;
    // min-height: auto;
  }

  .col-left, .col-right {
    // position: relative;
    display: block;
    width: 100%;
    // min-height: auto;
    min-height: 100vh;
  }

  .col-right {
    margin-left: 0;
    padding: 30px 20px 50px;
    // min-height: auto;
  }
}
</style>